function ensureChatbotOptions(options, currentId, labelMap) {
  const list = Array.isArray(options) ? options.slice() : []
  const id = String(currentId || '').trim()
  if (!id) return list
  for (let i = 0; i < list.length; i++) {
    if (list[i] && list[i].key === id) return list
  }
  const rest = list.filter(o => o && o.key)
  const label = (labelMap && labelMap[id]) || id
  return [{ key: id, label }].concat(rest.length ? rest : [])
}

export function getChatbotStartChatbotFieldDef(options, nodeData, labelMap) {
  const currentId = String((nodeData && nodeData.chatbotId) || '')
  return {
    title: 'Trigger Chatbot',
    formType: 'edit',
    ctaButtonText: 'Save',
    steps: [{
      fields: [
        {
          key: 'chatbotId',
          type: 'select',
          label: 'Chatbot',
          tip: 'Only Enabled chatbots can be started',
          options: ensureChatbotOptions(options, currentId, labelMap),
          v_required: { value: true, err: 'Select a chatbot' },
          placement: 'left',
        },
      ],
    }],
  }
}

export function startChatbotNodeDataToFormItem(data) {
  return { chatbotId: String((data && data.chatbotId) || '') }
}

export function formDataToStartChatbotNodeData(formData) {
  return { chatbotId: String((formData && formData.chatbotId) || '').trim() }
}

export function patchStartChatbotSelectOptions(fieldDef, options, currentId, labelMap) {
  const fields = fieldDef && fieldDef.steps && fieldDef.steps[0] && fieldDef.steps[0].fields
  if (!Array.isArray(fields)) return false
  for (let i = 0; i < fields.length; i++) {
    if (fields[i] && fields[i].key === 'chatbotId') {
      fields[i].options = ensureChatbotOptions(options, currentId, labelMap)
      return true
    }
  }
  return false
}
